import React, { useState } from 'react'
import { Alert, Text, Link } from '@amzn/storm-ui'
import styled from 'styled-components'
import { logger } from '../../utils/logger'
import { setNewFeatureCenterId } from '@amzn/intro-widgets-api'
import { useEmitInitialRender } from '../../utils/hooks'
import { ActionProp, ActionType } from '../../common/props'
import { dismissWidget } from '../../utils/functions'
import { WidgetTypes } from '../../common/constants'
import { logWithTakt } from '../../utils/takt'

export interface FeatureIntroductionAlertProps {
  title: string
  content: string
  action?: ActionProp
  anchorId: string
  dataTaktId: string
  isMobile: boolean
}

const StyledLink = styled(Link)`
  & {
    cursor: pointer;
  }
`

export const FeatureIntroductionAlert: React.FC<FeatureIntroductionAlertProps> = ({ title, content, action, anchorId, dataTaktId, isMobile }) => {
  useEmitInitialRender(WidgetTypes.FeatureIntroductionAlert)
  const [isOpen, setIsOpen] = useState(true)

  const handleClick = () => {
    if (!action) return

    switch (action.type) {
      case ActionType.OPEN_EXTERNAL_ACTION:
        window.open(action.link?.link, '_blank')
        break
      case ActionType.OPEN_INTERNAL_ACTION:
        window.open(action.link?.link, '_self')
        break
      case ActionType.OPEN_NEW_FEATURE_CENTER:
        setNewFeatureCenterId({ id: action.newFeatureCenterId })
        break
      default:
        logger.error(`Unsupported action type: ${action.type}`)
    }
  }

  const onClose = () => {
    dismissWidget(anchorId)
    setIsOpen(false)
    logWithTakt(`${WidgetTypes.FeatureIntroductionAlert}${isMobile ? 'Mobile' : 'Desktop'}`, { event: 'close' })
  }

  const label = action && (action.label || action.link?.label)

  return (
    <Alert type="feature-introduction" data-takt-id={dataTaktId} isOpen={isOpen} header={title} onClose={onClose} withCloseButton={true} hideIcon={true}>
      <Text>
        {content}&nbsp;
        {label && (
          <StyledLink data-takt-id={`${dataTaktId}_link`} onClick={handleClick}>
            {label}
          </StyledLink>
        )}
      </Text>
    </Alert>
  )
}
